/**
 * @generated SignedSource<<938070df7d9719f61ec9a07cd353d6c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders">;
  readonly " $fragmentType": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint";
}>;
export type async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint$key = ReadonlyArray<{
  readonly " $data"?: async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders"
    }
  ],
  "type": "DevOpsFeatureFlagProvider"
};

(node as any).hash = "17afe0c67200280c81407f20b1ac9cf2";

export default node;
